/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LocationTag
 */
export interface LocationTag {
  /**
   *
   * @type {number}
   * @memberof LocationTag
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof LocationTag
   */
  name: string
}

/**
 * Check if a given object implements the LocationTag interface.
 */
export function instanceOfLocationTag(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value

  return isInstance
}

export function LocationTagFromJSON(json: any): LocationTag {
  return LocationTagFromJSONTyped(json, false)
}

export function LocationTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationTag {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
  }
}

export function LocationTagToJSON(value?: LocationTag | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
